<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
  
    <CSidebarBrand class="d-md-down-none" to="/">
      <div class="img-container d-flex justify-content-left w-100">
        <img loading=lazy src="../assets/logo.png">
      </div>
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="navMenu"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import buildNavMenu from './_navMenu'

export default {
  name: 'TheSidebar',
  computed: {
    navMenu () {
      return buildNavMenu();
    },
    show () {
      return this.$store.state.sidebarShow
    },
    minimize () {
      return this.$store.state.sidebarMinimize
    },
  }
}
</script>

<style scoped>
/deep/.img-container
{
  padding-left: 16px;
}

/deep/.img-container > img
{
  height: 30px;
  width: auto;
}
</style>